import type { ReactNode } from "react";
import { Activity } from "lucide-react";
import EmptyState from "./EmptyState";
import { cn } from "@/utils/common.utils";

interface ActivityItem {
  id: string;
  user_name?: string;
  message?: string;
  [key: string]: unknown;
}

interface ActivityListProps {
  items: ActivityItem[];
  limit?: number;
  renderMeta?: (item: ActivityItem) => ReactNode;
  renderMessage?: (item: ActivityItem) => ReactNode;
  emptyTitle?: string;
  emptyDescription?: string;
  className?: string;
  itemClassName?: string;
}

export default function ActivityList({ items, limit, renderMeta, renderMessage, emptyTitle = "No activity yet", emptyDescription = "Updates will appear here as work progresses.", className, itemClassName }: ActivityListProps) {
  const visible = typeof limit === "number" ? items.slice(0, limit) : items;
  if (!visible.length) return <EmptyState compact icon={Activity} title={emptyTitle} description={emptyDescription} className="rounded-none border-0 px-2" />;
  return (
    <ul className={cn("flex flex-col gap-4", className)}>
      {visible.map((item) => (
        <li key={item.id} className={cn("text-sm", itemClassName)}>
          {renderMeta?.(item)}
          {renderMessage ? renderMessage(item) : <div className="leading-snug text-dash-ink"><span className="font-medium">{item.user_name}</span> {item.message}</div>}
        </li>
      ))}
    </ul>
  );
}
